import * as actionTypes from "../actionTypes/Index";
import { shipperInitialState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...shipperInitialState };

export default function shipperReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.ASSIGN_TOUR_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isTourAssigned: false,
        error: null,
      });
    }
    case actionTypes.ASSIGN_TOUR_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isTourAssigned: true,
      });
    }
    case actionTypes.ASSIGN_TOUR_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isTourAssigned: false,
        error: action.error,
      });
    }
    case actionTypes.ASSIGN_PLAN_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isPlanAssigned: false,
        error: null,
      });
    }
    case actionTypes.ASSIGN_PLAN_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isPlanAssigned: true,
      });
    }
    case actionTypes.ASSIGN_PLAN_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isPlanAssigned: false,
        error: action.error,
      });
    }
    case actionTypes.UPLOAD_TOUR_CSV_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isCsvUploaded: false,
        error: null,
      });
    }
    case actionTypes.UPLOAD_TOUR_CSV_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isCsvUploaded: true,
      });
    }
    case actionTypes.UPLOAD_TOUR_CSV_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isCsvUploading: false,
        error: action.error,
      });
    }
    case actionTypes.UPLOAD_3PL_PLAN_TOURS_CSV_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isSubmitted: false,
        error: null,
      });
    }
    case actionTypes.UPLOAD_3PL_PLAN_TOURS_CSV_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isSubmitted: true,
      });
    }
    case actionTypes.UPLOAD_3PL_PLAN_TOURS_CSV_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isSubmitted: false,
        error: action.error,
      });
    }

    default:
      return state;
  }
}
